// src/components/AnimationShowcase.jsx
import React from 'react';

const animations = [
  { name: 'float', className: 'animate-float' },
  { name: 'pulse', className: 'animate-pulse' },
  { name: 'grow', className: 'animate-grow' },
  { name: 'fade-in-up', className: 'animate-fade-in-up' },
];

const AnimationShowcase = () => {
  return (
    <section className="min-h-screen py-16 px-8 bg-gray-100">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">
        🎞️ Animation Showcase
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
        {animations.map((anim) => (
          <div key={anim.name} className="text-center">
            <div
              className={`w-32 h-32 rounded-xl bg-black text-white flex items-center justify-center mx-auto text-sm font-mono ${anim.className}`}
            >
              {anim.name}
            </div>
            <p className="mt-4 text-sm text-gray-600 font-mono">{anim.className}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AnimationShowcase;
